import axios from 'axios';
import { API_URL } from './constants/environment';

/**
 * Axios network config, retries + interceptors
 *
 */
axios.defaults.baseURL = API_URL;
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // if you have a magic url token, just proceed
        if (new URLSearchParams(location.search).has('token')) {
          return originalRequest;
        }

        // otherwise, try to get a refresh token
        const { data } = await axios.post<{ access_token: string }>(
          '/api/v1/authentication/token/refresh',
          {},
          {
            withCredentials: true
          }
        );
        const newToken = data.access_token;

        const tokenFromUrl = new URLSearchParams(location.search);

        if (newToken && !tokenFromUrl.has('token')) {
          axios.defaults.headers['Authorization'] = `Bearer ${newToken}`;
        }

        return axios(originalRequest);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);
